import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "config-list-header__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "config-list-header" }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "config-list-header__title" }, [
        _createElementVNode("h2", null, "Cashier settings")
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isChangeCountrySettingsAvailable)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              icon: _ctx.icons.Plus,
              disabled: _ctx.isCashierConfigListLoading,
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('show-add-country-dialog')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.CashierSettingsButtonName.ADD_COUNTRY), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["icon", "disabled"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_el_button, {
          circle: "",
          icon: _ctx.icons.Refresh,
          loading: _ctx.isCashierConfigListLoading,
          onClick: _ctx.getCashierConfigList
        }, null, 8 /* PROPS */, ["icon", "loading", "onClick"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}